import React from 'react';

interface FormCardProps {
  title?: string;
  columns?: number;
  children: React.ReactNode[] | React.ReactNode;
  disableBorder?: boolean;
  borderLeftOnly?: boolean;
}

export const FormCard = ({ title, children, columns, disableBorder, borderLeftOnly }: FormCardProps) => {
  const grid = React.useMemo(() => {
    const className =
      columns !== undefined && columns
        ? `grid grid-cols-${columns} gap-2 p-4 items-start`
        : `grid grid-cols-1 gap-2 p-4 items-start`;
    return <div className={className}>{children}</div>;
  }, [columns, children]);

  const borderStyle = React.useMemo(() => {
    if (disableBorder) return '';
    if (borderLeftOnly) return 'border-l-2 border-secondary-deep-blue-80';
    return 'border-2 border-secondary-deep-blue-80';
  }, [disableBorder, borderLeftOnly]);

  return (
    <div className={`flex flex-col w-full h-full ${borderStyle} mb-4`}>
      {title !== undefined && (
        <div className="pt-2 pl-3">
          <h2 className="text-2xl font-bold">{title}</h2>
        </div>
      )}
      {grid}
    </div>
  );
};
